import axios from 'axios';
import {
	ENDPOINT_URL,
	HOME_DASHBOARD_STATS_API,
} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Read a whole number from an API value.
 * @param {*} value API value
 * @return {number} count
 */
function count(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Report how many active Alarms there are, by severity.
 *
 * alarm_count is an object keyed by severity - {"Critical": 3464, "Major": 0,
 * "Minor": 0, "Info": 2} - not the plain number the other counts on this
 * payload are. Read as a number it comes back 0, which is a wrong answer
 * rather than a missing one, so each severity is pulled out by name and the
 * total summed from them.
 *
 * Keys are matched case-insensitively: the payload capitalises them and there
 * is no reason for an answer to depend on that holding.
 *
 * @return {Promise<{values: object}>} counts by severity plus the total
 */
export async function readAlarmCounts() {
	const {data} = await axios.get(`${ENDPOINT_URL}${HOME_DASHBOARD_STATS_API}`);
	const document = decodeAgentResponse(data) || {};
	const stats = document?.data ?? document;
	const raw = stats?.alarm_count;
	const bySeverity = {};
	if (raw && typeof raw === 'object') {
		for (const [key, value] of Object.entries(raw)) {
			bySeverity[String(key).toLowerCase()] = count(value);
		}
	}
	const critical = bySeverity.critical || 0;
	const major = bySeverity.major || 0;
	const minor = bySeverity.minor || 0;
	const info = bySeverity.info || 0;
	return {
		values: {
			critical,
			major,
			minor,
			info,
			total: Object.values(bySeverity).reduce((sum, n) => sum + n, 0),
		},
	};
}
